import React, { useEffect, useState } from "react";
import styles from "./ConnectStation2.module.css";
import { checkToken } from "../../Utils/TokenService";
import { useNavigate } from "react-router-dom";
import QrScannerComponent from "./QrScannerComponent/QrScannerComponent";
import config from "../../../settings/config";
import mobileSignal from "../../../img/signal.svg";
import { toast } from "react-toastify";
import Header from "../../Utils/Header/Header";
import localeRu from "../../../locales/ru/stations/connectStation2.json";
import localeEn from "../../../locales/en/stations/connectStation2.json";
import useAuthToken from "../../../hooks/useAuthToken";
import useStateBackend from "../../../hooks/useStateBackend";

const ConnectStation2 = () => {
  const errorsWithoutSn = ["402", "403", "405", "407", "411"];
  const [isScanning, setIsScanning] = useState(false);
  const [tempData, setTempData] = useState("");
  const [manualInput, setManualInput] = useState("");
  const [isManualInput, setIsManualInput] = useState(false);
  const [isAccess, setIsAccess] = useState(false);
  let lang = localStorage.getItem("language") === "ru";

  const navigate = useNavigate();
  // проверим токен для мобильного бэка

  useAuthToken();
  useStateBackend();

  const handleScan = (data) => {
    if (data && data.text && !isScanning) {
      const cleanedText = data.text.replace(/^http:\/\//, "");
      if (cleanedText.length >= 9 && tempData !== cleanedText) {
        setTempData(cleanedText);
        setIsScanning(true);
        getRequest(cleanedText).finally(setIsScanning(false));
      } else {
      }
    }
  };

  async function getRequest(data) {
    let requestType = "";
    if (isAccess) {
      requestType = "getshare";
    } else {
      requestType = "new";
    }
    try {
      const groupid = localStorage.getItem("groupId");
      // Выполняем запрос с параметрами
      const response = await fetch(
        `${config.app.host}/api/v1/station/${requestType}?sn=${data}&groupId=${groupid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("m_token")}`,
          },
        },
      );

      const responseData = await response.json(); // Переименовал переменную, чтобы избежать конфликта

      if (!response.ok) {
        const errorMessage = responseData?.message || "Неизвестная ошибка";
        const errorCode = responseData?.code || "Неизвестная ошибка";

        if (responseData.status === 400) {
          if (errorsWithoutSn.includes(errorCode)) {
            toast.warn(
              lang ? `${localeRu[errorCode]} ` : `${localeEn[errorCode]}`,
              {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
              },
            );
          } else {
            toast.warn(
              lang
                ? `${localeRu[errorCode]} ${data}`
                : `${localeEn[errorCode]} ${data}`,
              {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
              },
            );
          }

          navigate("/myStations");
          return;
        }
      }

      if (isAccess) {
        toast.success(lang ? localeRu.requestSend : localeEn.requestSend, {
          position: "top-center",
          autoClose: 3000,
          style: { color: "white", backgroundColor: "black" },
        });
        navigate("/myStations");
      } else {
        navigate("/connectComplete");
      }
    } catch (error) {
      toast.error(lang ? `${localeRu.error}` : `${localeEn.error}`, {
        position: "top-center",
        autoClose: 3000,
        style: { color: "white", backgroundColor: "black" },
      });
    }
  }

  const handleManualSubmit = () => {
    if (manualInput.length >= 9) {
      handleScan({ text: manualInput });
    } else {
      alert("Введите текст длиной не менее 9 символов");
    }
  };

  const handleManualInputChange = (e) => {
    setManualInput(e.target.value);
    setIsManualInput(e.target.value.length >= 1); // Когда пользователь начинает вводить текст
  };

  const handleError = (error) => {
    console.error("QR Scanner Error:", error);
  };

  const handleConnect = () => {
    navigate("/connect2");
  };

  const handleSkip = () => {
    navigate("/connect");
  };

  const handleSwitchAccess = () => {
    setIsAccess(!isAccess);
  };

  return (
    <div className={styles.container}>
      {/* <Header title={"Connect"} back={true} /> */}
      <div className={styles.section}>
        <h1 className={styles.titleText}>
          {lang ? localeRu.station_registration : localeEn.station_registration}
        </h1>

        {!isManualInput && (
          <div>
            <p>
              <br />
              {lang ? localeRu.scan_qr : localeEn.scan_qr}
            </p>
            <div className={styles.camContainer}>
              <QrScannerComponent onScan={handleScan} onError={handleError} />
            </div>
          </div>
        )}
        <p>
          <br />
          {lang ? localeRu.enter_manually : localeEn.enter_manually}
        </p>
        <div className={styles.manualInputContainer}>
          <input
            type="text"
            placeholder={
              lang
                ? localeRu.enter_station_number
                : localeEn.enter_station_number
            }
            value={manualInput}
            onChange={handleManualInputChange}
            className={styles.manualInput}
          />
        </div>
        {/* <div className={styles.requestAccess}>
                    Запрос доступа к станции
                    <div
                        className={isAccess ? styles.switchAccessOn : styles.switchAccess}
                        onClick={handleSwitchAccess}
                    >
                        <div className={styles.switch} />
                    </div>
                </div> */}
        {/* <button
                    type="button"
                    onClick={handleManualSubmit}
                    className={
                        manualInput.length >= 9
                            ? styles.submitButtonConnect // Активный стиль
                            : styles.submitButtonConnectDis // Неактивный стиль
                    }
                    disabled={manualInput.length < 9}
                >
                    <p className={styles.textButtons}>{isAccess ? (lang ? localeRu.share : localeEn.share) : (lang ? localeRu.connect : localeEn.connect)}</p>
                </button> */}
      </div>
      <div className={styles.sectionButton}>
        <button
          type="button"
          onClick={handleSkip}
          className={styles.submitButtonSkip}
        >
          <p className={styles.textButtonSkip}>
            {localStorage.getItem("language") === "ru"
              ? localeRu.back
              : localeEn.back}
          </p>
        </button>

        <button
          type="button"
          onClick={handleManualSubmit}
          className={
            manualInput.length >= 9
              ? styles.submitButtonConnect // Активный стиль
              : styles.submitButtonConnectDis // Неактивный стиль
          }
          disabled={manualInput.length < 9}
        >
          <p className={styles.textButtons}>
            {isAccess
              ? lang
                ? localeRu.share
                : localeEn.share
              : lang
              ? localeRu.connect
              : localeEn.connect}
          </p>
        </button>
      </div>
    </div>
  );
};

export default ConnectStation2;
